// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__XfV6S"};